import { FormattedMessage } from "react-intl";
import { IUserInfo } from "../../models/User";

// Import messages
import messages from "./module/messages";

// Import style
import classes from "./SidebarUserInfo.module.scss";

const SidebarUserInfo = (props: { user: IUserInfo }) => {
  const {
    name: firstName,
    surname: lastName,
    code: userId,
    organizational_unit: office,
  } = props.user;
  return (
    <div className={classes.wrapper}>
      <div>
        <FormattedMessage {...messages.firstName} />: <span>{firstName}</span>
      </div>
      <div>
        <FormattedMessage {...messages.lastName} />: <span>{lastName}</span>
      </div>
      <div>
        <FormattedMessage {...messages.userId} />: <span>{userId}</span>
      </div>
      <div>
        <FormattedMessage {...messages.office} />: <span>{office}</span>
      </div>
    </div>
  );
};

export default SidebarUserInfo;
